// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import qs from 'qs';
import Vue from 'vue';
import App from './App';
import router from './router';
import './assets/css/mobile.scss'
import './assets/css/pc.scss'
// scroller
import VueScroller from 'vue-scroller';
Vue.use(VueScroller);
// import { PullRefresh,List,Search} from 'vant';
// Vue.use(PullRefresh).use(List).use(Search);

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

//引入swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
import 'swiper/css/swiper.css'

import vshare from 'vshare'
//or require

Vue.use(vshare)

// 移动端编辑器
import "font-awesome/css/font-awesome.min.css"
import initRichText from './utils/initHTMLEditor';
initRichText();


import { Tabbar, TabbarItem ,Lazyload } from 'vant';
import 'vant/lib/index.css';

Vue.use(Tabbar).use(TabbarItem).use(Lazyload, {
  error: 'images/error.jpg',
  preLoad: 100,
  loading: '',
  attempt: 3
});
//toast
import { Toast } from 'vant';

Vue.use(Toast);

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// 引用API文件
import api from './api/index.js'
// 语言包：$T('中文键')，见 src/i18n
import i18n from './i18n';

Vue.use(i18n);
// 将API方法绑定到全局
Vue.prototype.$api = api;
Vue.prototype.copySuccess = function () {
  Vue.prototype.$toast( "复制成功");
};

Vue.filter('price', function (value) {
  return (value/100).toFixed(2);
});

 Vue.prototype.calculateTime = function (item) {
    var diff=item;
    var res = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    };
    if(diff > 0){
      var days = diff / 60 / 60 / 24 >= 1 ? Math.floor(diff / 60 / 60 / 24) : 0;

      var hours = diff / 60 / 60 % 24 >= 0 ? Math.floor(diff / 60 / 60 % 24) : 0;
      if(hours<10){
        hours='0'+hours
      }
      var minutes = diff / 60 % 60 >= 0 ? Math.floor(diff / 60 % 60) : 0;
      if(minutes<10){
        minutes='0'+minutes
      }
      var seconds = diff % 60 % 60  >= 0 ? Math.floor(diff % 60 % 60) : 0;
      if(seconds<10){
        seconds='0'+seconds
      }
      res = {
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds,
      };

      if(days){
        return '剩余'+days+':'+hours+':'+minutes+':'+seconds;
      }else if(hours){
        return '剩余'+hours+':'+minutes+':'+seconds;
      }else if(minutes){
        return '剩余'+minutes+':'+seconds;
      }else{
        return '剩余'+seconds;
      }
    }else{
      return '已结束';
    }
};



// lastTime
Vue.prototype.lastTime = function (diff){//lastTime是函数名
  let res = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  };
  if (diff > 0) {
    var days = diff / 60 / 60 / 24 >= 1 ? Math.floor(diff / 60 / 60 / 24) : 0;

    var hours = diff / 60 / 60 % 24 >= 0 ? Math.floor(diff / 60 / 60 % 24) : 0;
    if (hours < 10) {
      hours = '0' + hours
    }
    var minutes = diff / 60 % 60 >= 0 ? Math.floor(diff / 60 % 60) : 0;
    if (minutes < 10) {
      minutes = '0' + minutes
    }
    var seconds = diff % 60 % 60 >= 0 ? Math.floor(diff % 60 % 60) : 0;
    if (seconds < 10) {
      seconds = '0' + seconds
    }
    res = {
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: seconds,
    };
  }
  return res;
}

// dateFormat
Vue.prototype.dateFormat = function(strtime) {
  var date = new Date(strtime);
  let Y = date.getFullYear() + '-';
  let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
  let D = (date.getDate()+1 < 10 ? '0'+(date.getDate()) : date.getDate());
  /*let h = date.getHours() + ':';
  let m = date.getMinutes() + ':';
  let s = date.getSeconds();*/
  return Y+M+D;
}


Vue.filter('calculateTime', function (value) {
  return Vue.prototype.calculateTime(value);
});


Vue.filter('skuTitle', function (sku) {
  var skuTitle = "";
  for (var i=0,len=sku.length; i < len; i++) {
    skuTitle += sku[i].field+":"+sku[i].attr +" ";
  }
  return skuTitle;
});


Vue.config.productionTip = false;
router.beforeEach((to, from, next) => {
  // console.log('---router beforeEach--',to)
  if (to.query._seller_id) {
    localStorage.setItem("_seller_id",to.query._seller_id);
  }
  if (!localStorage.getItem("_user_mark") && to.query._user_mark) {
    localStorage.setItem("_user_mark",to.query._user_mark);
  }
  if (to.query._closecode) {
    localStorage.setItem("_closecode", to.query._closecode);  
  }
  if (!sessionStorage.getItem("wx_entry_url")) {
    sessionStorage.setItem("wx_entry_url",document.URL);
  }
  if (to.query._bind_phone) {
    localStorage.setItem("_bind_phone",1);
  }
  if (to.query._openid) {
    localStorage.setItem("_openid",to.query._openid);
  }
  if (to.query._token) {
    localStorage.setItem("_token",to.query._token.replace(/ /g,'+'));
  }
  next();
});

window.rbMessage = function (e) {
  // alert(e.data);
}
document.addEventListener('message', function (e) {
    // alert('message'+JSON.stringify(e.data));
  window.rbMessage(e.data);
});


window.isWeixin = function(){
  var ua = navigator.userAgent.toLowerCase();
  if(ua.match(/MicroMessenger/i)=="micromessenger") {
    return true;
  } else {
    return false;
  }
}

Vue.prototype.isAndroid = function () {
  var u = navigator.userAgent;
  console.log(u);
  if(u.indexOf('Android') > -1 || u.indexOf('Linux') > -1){
    return true;
  }else{
    return false;
  }
}

window.isApp = function () {
  // return true;
  var u = navigator.userAgent;
  if(u.indexOf('Rbapp') > -1){
    return true;
  }else{
    return false;
  }
}

Vue.prototype.wxShare = function (title, desc, link ,imgUrl) {
  //const url = document.location.href;// 当前url
  let self = this;
  // alert(self.isAndroid() );
  // alert(document.location.href );
  // alert(sessionStorage.getItem("wx_entry_url"));
  self.$api.get('/api/weixin/jsConfig', {
    "url" : self.isAndroid() ?  document.location.href : sessionStorage.getItem("wx_entry_url") //url
  }, r1 => {
    wx.config(r1.data);
    wx.ready(() =>{
      wx.onMenuShareAppMessage({ // 分享给朋友
        title: title,       // 分享标题
        desc: desc,   // 分享描述
        link: link,       // 分享链接 默认以当前链接
        imgUrl:  imgUrl,// 分享图标
        // 用户确认分享后执行的回调函数
        success: function () {
          // alert('sharesuccess');
        },
        // 用户取消分享后执行的回调函数
        cancel: function () {
          console.log('分享到朋友取消');
        }
      });
      //分享到朋友圈
      wx.onMenuShareTimeline({
        title: title,       // 分享标题
        link: link,       // 分享链接 默认以当前链接
        imgUrl:  imgUrl,// 分享图标
        success: function () {
          // 用户确认分享后执行的回调函数
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
        }
      });
    });
  });

};

window.rbTitle = function(title){
  if(window.isApp()){
    let postData = {
      'action':'title',
      'value': title
    }
    // alert('发送'+JSON.stringify(postData));
    setTimeout(function () {
      window.postMessage(JSON.stringify(postData));
    },300)
  }else{
    document.title = title;
  }
}

window.rbLink = function(link,method){
  if(window.isApp()){
    //app跳页面
    let value = '';
    if(method=='replace'){
      // value = link.name.substring(0,1).toUpperCase()+link.name.substring(1);

      // name=1&id=121
      value = window.h5DevRoot+link.name+'?'+qs.stringify(link.query);
    }else{
      value = window.h5DevRoot+link.name+'?'+qs.stringify(link.query);
    }
    let postData = {
      'action':'url',
      'method': method||'push',
      'name': link.name.substring(0,1).toUpperCase()+link.name.substring(1),
      'query':link.query
    }
    // alert(JSON.stringify(postData));
    window.postMessage(JSON.stringify(postData));
  }else{
    //vue跳页面
    if(method!="back"){
      if(method=='replace'){
        selfVue.$router.replace(link);
      }else{
        selfVue.$router.push(link);
      }
    }else{
      selfVue.$router.back();
    }
  }
}

window.appEvent = function(Event){
  if(window.isApp()){
    let postData = {
      'action':'event',
      'name': Event.name,
      'query':Event.query
    }
    // alert(JSON.stringify(postData));
    window.postMessage(JSON.stringify(postData));
  } else {
    if(Event.query.url) {
      window.open(Event.query.url)
      return
    } else {
      // selfVue.$message.error('当前文件链接不可用')
    }
  }
}



//将时间戳转成格式时间的时间 过滤器
Vue.filter('monthForm', function (value) {
  if (!value) {
    return '';
  }
  var time = new Date(parseInt(value)*1000);
  var m = time.getMonth() + 1;
  m = m.toString();
  if (m.length <= 1) {
    m = '0' + m;
  }
  return m;
})
Vue.filter('yearForm', function (value) {
  if (!value) {
    return '';
  }
  var time = new Date(parseInt(value)*1000);
  return time.getFullYear();
})
Vue.filter('dayForm', function (value) {
  if (!value) {
    return '';
  }
  var time = new Date(parseInt(value)*1000);
  var d = time.getDate();
  d = d.toString();
  if (d.length <= 1) {
    d = '0' + d;
  }
  return d;
})

Vue.filter('dayForm', function (value) {
  if (!value) {
    return '';
  }
  var time = new Date(parseInt(value)*1000);
  var d = time.getDate();
  d = d.toString();
  if (d.length <= 1) {
    d = '0' + d;
  }
  return d;
})

Vue.filter('timeFormatSimple', function (timestamp) {
  var time = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let year = time.getFullYear()
  let month = time.getMonth() + 1
  let date = time.getDate()
  let hours = time.getHours()
  let minute = time.getMinutes()
  let second = time.getSeconds()

  if (month < 10) { month = '0' + month }
  if (date < 10) { date = '0' + date }
  if (hours < 10) { hours = '0' + hours }
  if (minute < 10) { minute = '0' + minute }
  if (second < 10) { second = '0' + second }
  return year + '-' + month + '-' + date
})

Vue.filter('timeFormat', function (timestamp) {
  var time = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let year = time.getFullYear()
  let month = time.getMonth() + 1
  let date = time.getDate()
  let hours = time.getHours()
  let minute = time.getMinutes()
  let second = time.getSeconds()

  if (month < 10) { month = '0' + month }
  if (date < 10) { date = '0' + date }
  if (hours < 10) { hours = '0' + hours }
  if (minute < 10) { minute = '0' + minute }
  if (second < 10) { second = '0' + second }
  return year + '-' + month + '-' + date + ' ' + hours + ':' + minute + ':' + second
})


















function v_link_click(event,m) {
  var el=event.currentTarget;
  var link=el.getAttribute("rblink");
  link =JSON.parse(link);
  if(!link){
    console.log(el);
  }
  let type = 'push';
  var replace=el.getAttribute("rb-replace");
  if(replace=='true'){
    type ='replace'
  }
  var back=el.getAttribute("rb-back");
  if(back=='true'){
    type ='back'
  }
  var arg=el.getAttribute("rb-arg");
  console.log('跳链接');
  console.log(link);
  // alert(type);
  rbLink(link,type);
  // ;
  // Rap.go(link,replace=='true');
}

Vue.directive('rblink', {
  bind: function (el, binding, vnode) {
    el.setAttribute("rblink", JSON.stringify(binding.value));
    var modifiers=binding.modifiers;
    // if(binding.value.name=='orderManage'){
      // alert(JSON.stringify(binding));
    // }

    if(modifiers.replace){
      el.setAttribute("rb-replace", 'true');
    }
    if(modifiers.back){
      el.setAttribute("rb-back", 'true');
    }
    if(binding.arg){
      el.setAttribute("rb-arg", binding.arg);
    }
    if(el.addEventListener) {
      el.addEventListener('click',v_link_click,false);
    }
    //ie使用attachEvent，来添加事件
    else {
      el.attachEvent("onclick",v_link_click);
    }
  },
  update:function (el, binding, vnode) {
    el.setAttribute("rlink", binding.value);
  },unbind:function (el, binding, vnode) {
    if(el.removeEventListener){
      el.removeEventListener("click",v_link_click,false);
    }else{
      el.detachEvent("click",v_link_click);
    }
  }
});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  data: {
  },
  mounted: function(){
      window.selfVue = this;
  },
});

function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]); return null;
}



// WEBPACK FOOTER //
// ./src/main.js